// const delivery__wrapper = document.querySelector('.delivery__popup__wrapper');
// const close__delivery_popup = document.querySelector('.close__delivery_popup svg');
// const open__delivery__popup = document.querySelector('.additional__info__product.delivery');

// if (open__delivery__popup) {
//   open__delivery__popup.addEventListener('click', () => {
//     delivery__wrapper.classList.add('active');
//     });
// }

// if (close__delivery_popup) {
//   close__delivery_popup.addEventListener('click', () => {
//     delivery__wrapper.classList.remove('active');
//     });
// }
